import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function MobileUsersCtrl ($rootScope, $state, $scope, $translate, workshopAPI) {
  $scope.showMobileUsers = false;

  $scope.filtering = {
    value: ''
  };

  $scope.tableSettings = {
    broadcast: 'filterMobileUsers',
    columns  : [
      {
        field : 'username',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.USERNAME')
        }
      },
      {
        field : 'state',
        header: {
          text: $translate.instant('COMPANY_SPACE.USERS.USER')
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewUser(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_USERS')
    },
    pagination: {
      enabled   : true,
      pageSize  : 10,
      pageSizes : [ 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/filters/count', [
        $scope.filtering.value || '*',
        'mobile_users',
        false
      ])
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      direction: 'asc',
      enabled  : true,
      field    : 'username'
    },
  };

  $scope.getUsers = ( params ) => {
    return workshopAPI.stream('/filters', [
      $scope.filtering.value || '*',
      'mobile_users',
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
      false
    ]).then(function (users) {
      $scope.users = users;
      $scope.showMobileUsers = !!users.length;
      return users;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewUser(event.row);
  };

  $scope.viewUser = function (event) {
    $state.go('app.mobile-user', {
      id         : event.id,
      mechanic_id: event.mechanic_id
    });
  };

  $scope.$watch('filtering.value', function (newVal, oldVal) {
    if (newVal !== oldVal) {
      window['filterMobileUsers']();
    }
  });

  $scope.getUsers({
    offset   : 0,
    pageSize : 11,
    field    : 'username',
    direction: 'asc'
  });
}